import type { SVGProps } from 'react';
const SvgIconUnlock = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 4.75A3.75 3.75 0 0 1 7.75 1h.5a3.75 3.75 0 0 1 3.602 2.703c.044.152-.075.297-.233.297h-1.07a.27.27 0 0 1-.242-.164A2.25 2.25 0 0 0 8.25 2.5h-.5A2.25 2.25 0 0 0 5.5 4.75V6h6A2.5 2.5 0 0 1 14 8.5v4a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 12.5v-4a2.5 2.5 0 0 1 2-2.45zM3.5 8.5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconUnlock;
